import React, { useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { FaUserSlash, FaEnvelope, FaCommentDots } from "react-icons/fa";
import axios from 'axios';
import { TiUser } from "react-icons/ti";
import ToastNotification from "../../components/ToastNotification/ToastNotification";
const DeleteAccount = () => {
  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });
  const showToast = (msg, bg = 'success') => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const [formData, setFormData] = useState({
    user_id: "",
    email: "",
    message: "",
    type: 'Delete'
  });
  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const getInputStyle = fieldName => ({
    padding: "14px",
    borderRadius: "10px",
    border: "1px solid #ced4da",
    boxShadow:  "none",
    outline: "none",
    transition: "0.3s"
  });
  const handleSubmit = async e => {
    e.preventDefault();
    try {
      await axios.post("https://api.sweepydo.in/contact-us", {
        name: formData.user_id,
        email: formData.email,
        message: formData.message,
        type: "Delete"
      });
      showToast("Delete request submitted successfully", 'success');
      setFormData({
        user_id: "",
        email: "",
        message: ""
      });
    } catch (error) {
      console.log(error);
      showToast("Failed to send request", 'danger');
    }
  };
  return <section style={{
    minHeight: "100vh",
    background: "linear-gradient(135deg, #f8f9fa 0%, #eef7f1 100%)",
    padding: "80px 0",
    display: "flex",
    alignItems: "center"
  }}>
               <ToastNotification show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({
      ...toast,
      show: false
    })} />
            <Container>
                <Row className="justify-content-center">
                    <Col lg={6} md={8}>
                        <Card style={{
            border: "none",
            borderRadius: "24px",
            overflow: "hidden",
            boxShadow: "0 12px 35px rgba(0,0,0,0.08)"
          }}>
                            {/* Header */}
                            <div style={{
              background: "linear-gradient(90deg, #05AC5F, #048a4c)",
              padding: "30px",
              textAlign: "center",
              color: "#fff"
            }}>
                                <div style={{
                width: "70px",
                height: "70px",
                margin: "0 auto 15px",
                borderRadius: "50%",
                background: "rgba(255,255,255,0.15)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}>
                                    <FaUserSlash size={28} />
                                </div>

                                <h2 style={{
                margin: 0,
                fontWeight: "700"
              }}>
                                    Delete Account Request
                                </h2>

                                <p style={{
                marginTop: "8px",
                marginBottom: 0,
                opacity: 0.9
              }}>
                                    Please fill in your details below
                                </p>
                            </div>


                            <Card.Body style={{
              padding: "35px"
            }}>
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-4 fw-bold">
                                        <Form.Label>
                                            <TiUser style={{
                      marginRight: "8px"
                    }} />
                                            User ID
                                        </Form.Label>
                                        <Form.Control type="text" name="user_id" value={formData.user_id} onChange={handleChange} placeholder="Enter your User ID" style={getInputStyle("mobile")} />
                                    </Form.Group>

                                    <Form.Group className="mb-4 fw-bold">
                                        <Form.Label>
                                            <FaEnvelope style={{
                      marginRight: "8px"
                    }} />
                                            Email Address
                                        </Form.Label>
                                        <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Enter email address" style={getInputStyle("email")} />
                                    </Form.Group>

                                    <Form.Group className="mb-4 fw-bold">
                                        <Form.Label>
                                            <FaCommentDots style={{
                      marginRight: "8px"
                    }} />
                                            Reason for Account Deletion
                                        </Form.Label>
                                        <Form.Control as="textarea" rows={4} name="message" value={formData.message} onChange={handleChange} placeholder="Reason for deletion" style={getInputStyle("reason")} />
                                    </Form.Group>

                                    <Button type="submit" style={{
                  width: "100%",
                  background: "#05AC5F",
                  border: "none",
                  padding: "14px",
                  fontWeight: "600",
                  borderRadius: "10px",
                  fontSize: "16px"
                }}>
                                        Request Account Deletion
                                    </Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>;
};
export default DeleteAccount;
